var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, keyframes } from 'goober';
import { forwardRef } from 'react';
export var Text = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.ui.dark,
        fontSize: theme.font.size,
    });
});
export var TextOverflowEllipsis = styled('p')(function (_a) {
    var theme = _a.theme;
    return ({
        margin: '0px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    });
});
export var Button = styled('button')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        cursor: 'default',
        justifyContent: 'space-evenly',
        minWidth: '80px',
        minHeight: '25px',
        alignItems: 'center',
        padding: '5px 15px',
        fontSize: theme.font.size,
        transition: 'none 0s ease 0s',
        borderWidth: '2px',
        borderStyle: 'solid',
        outline: 'none',
        boxSizing: 'border-box',
        borderRadius: '1000px',
        '&:disabled': {
            backgroundColor: theme.colors.neutral.w300,
            borderColor: theme.colors.neutral.w300,
            color: theme.colors.neutral.w700,
            pointerEvents: 'none',
        },
    });
});
var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
export var Loading = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$size, $size = _b === void 0 ? 1 : _b, $color = _a.$color;
    return ({
        border: "3px solid ".concat(theme.borderColor),
        borderTop: "3px solid ".concat($color !== null && $color !== void 0 ? $color : theme.colors.ui.dark),
        borderRadius: '50%',
        width: "".concat(20 * $size, "px"),
        height: "".concat(20 * $size, "px"),
        animation: "".concat(spin, " 2s linear infinite"),
        position: 'absolute',
    });
});
export var LoadingWrap = styled('div')(function (_a) {
    var $dimBg = _a.$dimBg, $dimBgLight = _a.$dimBgLight;
    return ({
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        zIndex: 10000,
        backgroundColor: $dimBg ? ($dimBgLight ? 'rgba(255, 255, 255, 0.3)' : 'rgb(0, 0, 0, 0.3)') : 'transparent',
    });
});
export var SelectionDiv = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        background: theme.colors.neutral.w100,
        color: theme.colors.ui.dark,
        padding: '0px 10px',
        borderRadius: '6px',
        fontWeight: 'bold',
        fontSize: '12px',
        lineHeight: '24px',
        bottom: '30px',
        right: '30px',
        span: {
            color: theme.colors.neutral.w700,
            fontWeight: 'normal',
        },
    });
});
export var TagBadge = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.primary.w500,
        padding: '5px 10px',
        borderRadius: '6px',
        fontSize: '11px',
        lineHeight: 1,
        height: '24px',
        backgroundColor: theme.colors.primary.w50,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        flexShrink: 1,
        '&.acc': {
            backgroundColor: theme.colors.secondary.w50,
            color: theme.colors.secondary.w500,
        },
        '&.table': {
            backgroundColor: theme.colors.primary.w500,
            color: theme.colors.ui.white,
        },
        '&.func': {
            backgroundColor: theme.colors.function.w50,
            color: theme.colors.function.w500,
        },
        '&.property': {
            backgroundColor: theme.colors.neutral.w200,
            color: theme.colors.ui.dark,
        },
        '&.transparent': {
            backgroundColor: 'transparent',
            color: theme.colors.ui.dark,
        },
        '.remove': {
            paddingLeft: '5px',
            cursor: 'pointer',
            lineHeight: 1,
            paddingTop: '2px',
        },
        '&.tiny': {
            height: '18px',
        },
    });
});
export var TagAddButtonAndLabel = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        '&.dimension button': {
            color: theme.colors.primary.w500,
        },
        '&.account button': {
            color: theme.colors.secondary.w500,
        },
        '&.table button': {
            color: theme.colors.primary.w500,
        },
        label: {
            fontWeight: 'bold',
            paddingLeft: '10px',
        },
        '&.dimension label': {
            color: theme.colors.primary.w500,
        },
        '&.account label': {
            color: theme.colors.secondary.w500,
        },
        '&.table label': {
            color: theme.colors.primary.w500,
        },
    });
});
export var BasicTitle = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.ui.dark,
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: '800',
    });
});
export var OverlayTooltip = styled('div', forwardRef)(function () { return ({
    pre: {
        whiteSpace: 'pre-wrap',
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
        border: 'none',
        color: 'inherit',
        textAlign: 'left',
        fontSize: '15px',
        lineHeight: 1.42857,
        fontFamily: '"Open Sans", sans-serif',
        wordBreak: 'keep-all',
    },
}); });
export var Bubble = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        background: theme.colors.error.w500,
        color: '#fff',
        fontSize: '9px',
        position: 'absolute',
        top: '4px',
        right: '12px',
        width: '15px',
        height: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
    });
});
var templateObject_1;
